import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';

const App = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate(`${ROUTE_KEYS.APP}/${ROUTE_KEYS.GET_STARTED}`, { replace: true });
  }, []);
  return <div />;
};

export default App;
